module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/mark_warning-018ce5c54030e3a6e44375e6a0840126.gif";